<script setup>
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useScreensizeStore } from '@stores/useScreensizeStore.ts';
import GoogleMap from '@components/GoogleMap.vue';
import GoogleMapStatic from '@components/GoogleMapStatic.vue';
import { trans } from '@tools/translation';

const address = ref(window.initialAppState?.address ?? window.address);
const circleOptions = ref(window.mapCircleOptions ?? {});
const isGoogleMapModalOpen = ref(false);

const { isMobileOrTablet } = storeToRefs(useScreensizeStore());
</script>

<template>
  <div class="map-location">
    <GoogleMap
      :latitude="address.latitude"
      :longitude="address.longitude"
      :height="isMobileOrTablet ? 280 : 344"
      :zoom="14"
      :circle-options="circleOptions"
      is-static
      with-circle
      @click="isGoogleMapModalOpen = true"
    />

    <button
      class="map-location__button"
      @click="isGoogleMapModalOpen = true"
    >
      <span>
        {{ trans('map.location.button.extend') }}
      </span>

      <span class="map-location__button__icon" />
    </button>

    <!--  @TODO: Refactor this logic in assets/scripts/organisms/google-map.js by passing props -->
    <input id="address-lng" type="hidden" :value="address.longitude">
    <input id="address-lat" type="hidden" :value="address.latitude">

    <GoogleMapStatic
      :is-opened="isGoogleMapModalOpen"
      @close="isGoogleMapModalOpen = false"
    />
  </div>
</template>

<style lang="scss" scoped>
@use '@styles/components/map-location';
</style>
